$( document ).ready(function() {

    var hover_id, click_id, chain_select, chain_price, chain_title, chain_price2;
    var chain_id, chain_var, chain_title, chain_html, now_chain;

    // Chain selection hover states
    $( ".charmbar_radio" )
    .mouseenter(function() {
      hover_id = $(this).attr("data-id");
      $('.cb_chain_price[data-id="' + hover_id + '"]').addClass("hover");
    })
    .mouseleave(function() {
      hover_id = $(this).attr("data-id");
      $('.cb_chain_price[data-id="' + hover_id + '"]').removeClass("hover");
    });

    // Chain click actions
    $( ".charmbar_radio" ).not(".unavailable").click(function() {
      $('.charmbar_radio, .cb_chain_price, .cb_chain_prod').removeClass("selected"); 
      // Get attributes 
      chain_id = $(this).attr("data-id");
      chain_select = $('.cb_chain_price[data-id="' + chain_id + '"]')
      chain_price = $(this).attr("data-price");
      chain_price2 = $(chain_select).text();
      chain_title = $(chain_select).attr("data-title");
      chain_var = $(this).find('span').text();
      chain_title = $(this).closest('.cb_chain_prod').find('.cb_chain_title h1').text();
      // Charm Section Update
      $(this).addClass("selected");
      $(chain_select).addClass("selected");
      $(this).closest('.cb_chain_prod').addClass('selected');
      $('#cb_chain_grid').addClass('active');
    });

    // Chain Addcart
    var chain_review = $('#cb_chainreview');
    var chain_template = $('#cb_chainreview_template');
    $( ".mixbutton_chain" ).click(function() {
      var nowchain = $('.cb_chainreview_row').filter('[data-id="' + chain_id + '"]');
      // If doesn't exist Create new row
      if ( nowchain.length == 0 ) {
        chain_html = $(chain_template).clone().attr("id", "").attr("data-id", chain_id).addClass("cb_chainreview_row");
        $(chain_review).append(chain_html);
        nowchain = $('.cb_chainreview_row').filter('[data-id="' + chain_id + '"]');
        // Add details to row
        $(nowchain).find('.chainreview_title').append(chain_title, " - ", chain_var, "&quot;")
            .siblings('.chainreview_price').text(chain_price2)
            .closest('.cb_chainreview_row').find('.quant_input').attr("data-price", chain_price);
      } 
      else {
        var new_total = $(nowchain).find('.quant_input').attr("data-count") * 1 + 1;
        $(nowchain).find('.quant_input').attr("data-count", new_total);
      }
      // Update subtotal
      subtotal_update($('.charmbar_radio.selected'), 'plus', 'chain');
      // Remove inactive class from container
      if ( $(chain_review).hasClass('inactive') ) $(chain_review).removeClass('inactive');
      // Reset chain selection
      $('.charmbar_radio, .cb_chain_price, .cb_chain_prod').removeClass("selected");
      $('#cb_chain_grid').removeClass("active");
    });

    // Chain Review Quant Click 

    $( "#cb_chainreview" ).on("click", ".quant_plus", function(){
      var chain_quant = $(this).siblings('.quant_input');
      var new_total = $(chain_quant).attr("data-count") * 1 + 1;
      $(chain_quant).attr("data-count", new_total);
      subtotal_update(chain_quant, "plus", "chain");
    });

    $( "#cb_chainreview" ).on("click", ".quant_minus", function(){
      var chain_quant = $(this).siblings('.quant_input');
      var new_total = $(chain_quant).attr("data-count") * 1 - 1;
      // Only do something if total is > 0
      if ( new_total > 0 ) {
        $(chain_quant).attr("data-count", new_total);
        subtotal_update(chain_quant, "minus", "chain");
      }
      else {
        $(this).closest('.cb_chainreview_row').remove();
        if ( $('.cb_chainreview_row').length == 0 ) $(chain_review).addClass('inactive');
      }
    });

    // Charm quant click
    $('.mixprod .quant_plus').click(function(){
      // Update input
      var new_total = $(this).siblings('.quant_input').attr("data-count") * 1 + 1;
      $(this).siblings('.quant_input').attr("data-count", new_total);
      // Find section type
      subtotal_update($(this));
    });

    $('.mixprod .quant_minus').click(function(){
      var new_total = $(this).siblings('.quant_input').attr("data-count") * 1 - 1;
      // Only do something if total is > 0
      if ( new_total >= 0 ) {
        $(this).siblings('.quant_input').attr("data-count", new_total);
        subtotal_update($(this), 'minus');
      }
    });

    var prod_price, prod_type, count_select, price_select, new_count, new_price, price_print;

    function subtotal_update(selection, action="plus", type="non_chain") {
      if ( type == 'chain' ) { // If chain then selection gives price holder
        prod_price = $(selection).attr("data-price");
        prod_type = "chain";
      }
      else {
        prod_price = $(selection).closest('.mixprod').attr("data-price");
        prod_type = $(selection).closest('.grid_collect').attr("data-type");
      }
     
      count_select = '#cb_count_' + prod_type;
      price_select = '#cb_price_' + prod_type;
      // Plus or minus
      if ( action == 'plus' ) {
        new_count = $(count_select).attr("data-count") * 1 + 1;
        new_price = $(price_select).attr("data-price") * 1 + prod_price * 1;
        // Show bottom button if item added to cart... could potentially check if there are 0 and hide but this is best solution for now
        $('#charmbar_cta_button').addClass('active');
      }
      else {
        new_count = $(count_select).attr("data-count") * 1 - 1;
        new_price = $(price_select).attr("data-price") * 1 - prod_price * 1;
      }
      // Update count
      $(count_select).attr("data-count", new_count);

      // Update price
      var price_print = (new_price / 100 ).toLocaleString("en-US", {style:"currency", currency:"USD"});
      $(price_select).attr("data-price", new_price).html(price_print);

      // Update price total
      var total_price = ($('#cb_price_chain').attr("data-price") * 1) + ($('#cb_price_charm').attr("data-price") * 1) + ($('#cb_price_letter').attr("data-price") * 1);
        total_price = total_price + ($('#cb_price_zodiac').attr("data-price") * 1);
      var total_print = (total_price / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
      $('#cb_subtotal').attr("data-price", total_price).html(total_print);
    }

    var mix_id, quant, chain_id, mixcount, init_count, now_count;
    var chain_list = [];
    var chain_id, chain_quant;


    // Adding mixmatch product to cart
    $('#mixmatch_addcart').not('.loading').click(async function(event) {
        event.preventDefault();
        $(this).addClass("loading");
      
        try {
            // Add charms to the cart
            const charmPromises = [];
            $('.mixprod').each(function(index, element) {
              const quant = $(element).find('.quant_input').attr("data-count");
              const prod_type = $(this).closest('.grid_collect').attr("data-type");
              if (quant && quant != 0) {
                const mix_id = $(element).attr("data-id");
                charmPromises.push(
                  window.liquidAjaxCart.add({
                    items: [
                      {
                        id: mix_id,
                        quantity: parseInt(quant),
                        properties: {
                          "Charmbar": prod_type
                        }
                      }
                    ]
                  })
                );
              }
            });
          
            // Add chains to the cart
            const chainList = [];
            $('#cb_chainreview').find('.cb_chainreview_row').each(function() {
            const chain_id = $(this).attr("data-id");
            const chain_quant = $(this).find('.quant_input').attr("data-count");
            if (chain_quant && chain_quant != 0) {
                console.log('Adding chain to cart:', {
                id: chain_id,
                quantity: chain_quant,
                properties: {
                    "Charmbar": "Chain"
                }
                });
                chainList.push({
                id: chain_id,
                quantity: parseInt(chain_quant),
                properties: {
                    "Charmbar": "Chain"
                }
                });
            }
            });
          
            if (chainList.length > 0) {
              charmPromises.push(window.liquidAjaxCart.add({ items: chainList }));
            }
          
            // Wait for all items to be added
            await Promise.all(charmPromises);
          
            // Check if liquidAjaxCart is still processing
            const checkProcessing = setInterval(() => {
                if (!window.liquidAjaxCart.processing) {
                clearInterval(checkProcessing);
        
                // Reset the UI
                $('.cb_contents_row .cb_count').attr("data-count", "0"); // Clears x amount in subtotals
                $('.cb_contents_row h2').attr("data-price", "0").html("$0.00"); // Clears $amount and data
                $('.mixprod .quant_input').attr("data-count", 0); // Clears individual data counts
                $('#cb_chainreview').addClass('inactive');
                $('.cb_chainreview_row').remove();
        
                // Remove loading state
                $('#mixmatch_addcart').removeClass('loading');
                }
            }, 100); // Check every 100ms
          } catch (error) {
            console.error("Error adding items to cart:", error);
            // Handle errors (e.g., display a message to the customer)
            $('#mixmatch_addcart').removeClass('loading');
          }
    // End of addcart function

    var now_el, copythis;

    // Side Bar Actions

    // Sidebar add quant
    $("#mixmatch_sidebar").on("click", ".quant_plus", function(){
      // Update current input
      var new_total = $(this).siblings('.quant_input').attr("data-count") * 1 + 1;
      $(this).siblings('.quant_input').attr("data-count", new_total);
      // Find clone
      var now_id = $(this).closest('.mixprod').attr("data-id");
      var clone = $('.grid_collect .mixprod[data-id="' + now_id + '"]');
      var clone_input = $(clone).find('.quant_plus');
      // Update original clone input
      $(clone).find('.quant_input').attr("data-count", new_total);
      // Input clone quant_plus to subtotal update function
      subtotal_update(clone_input);
    });

    // Sidebar sub quant 
    $("#mixmatch_sidebar").on("click", ".quant_minus", function(){
      var new_total = $(this).siblings('.quant_input').attr("data-count") * 1 - 1;
      // Only do something if total is > 0
      if ( new_total >= 0 ) {
        $(this).siblings('.quant_input').attr("data-count", new_total);
        // Find clone
        var now_id = $(this).closest('.mixprod').attr("data-id");
        var clone = $('.grid_collect .mixprod[data-id="' + now_id + '"]');
        var clone_input = $(clone).find('.quant_minus');
        // Update original clone input
        $(clone).find('.quant_input').attr("data-count", new_total);
        // Input clone quant_plus to subtotal update function
        subtotal_update(clone_input, 'minus');
      }
    }); 

    // Info Reveal
    $('.mixmatch_infoclick .icon-plus').click(function(){
      $('body').addClass("mixmatch_infoshow");
      now_el = $(this).closest('.mixprod');
      $('#mixmatch_sidebar').addClass("active");

      // Clone function
      copythis = $(now_el).clone();
      $( "#mixmatch_sidebar_inner" ).html(copythis);

      // Change Clone
      $('#mixmatch_nav_prev').click(function(){
        var prev_el = $(now_el).prev();
        if ( prev_el.length > 0 ) {
          $( "#mixmatch_sidebar_inner" ).html( $(prev_el).clone() );
          now_el = $(now_el).prev();
        }
      });

      $('#mixmatch_nav_next').click(function(){
        var next_el = $(now_el).next();
        if ( next_el.length > 0 ) {
          $( "#mixmatch_sidebar_inner" ).html( $(next_el).clone() );
          now_el = $(now_el).next();
        }
      });

    });

    $("#mixmatch_sidebar_close").click(function(){
      $('#mixmatch_sidebar').removeClass("active");
      $('body').removeClass("mixmatch_infoshow");
    });

    // Hide sidebar if clicked outside while

    $(document).on("click", function(event){
      if( $('body').hasClass("mixmatch_infoshow") && !$(event.target).closest("#mixmatch_sidebar").length && !$(event.target).closest(".mixmatch_infoclick").length ){
        $('#mixmatch_sidebar').removeClass("active");
        $('body').removeClass("mixmatch_infoshow");
      }
    });

    // Charmbar CTA button 

    $('#mixmatch_bottom').waypoint(function(direction) {
      if (direction === 'down') $('#charmbar_cta_button').addClass('hide');
      else $('#charmbar_cta_button').removeClass('hide');
    }, { offset: 'bottom-in-view' });

  });
});